import { isMatch, isTube } from '../articles/helpers';
import { PROJECT_CREATION_LEVELS } from './constants';
import { ICreationProduct } from './interfaces';

export const reduceCreatioProjectProduct = (products: ICreationProduct | ICreationProduct[], fieldTarget: string) => {
  const { COMPOSITIONS, ARTICLES, PARTS } = PROJECT_CREATION_LEVELS;
  const parts = [];

  const targetLevel = Array.isArray(products)
    ? products.map((product) => ({
      id: product._id.$oid || product.id,
      [fieldTarget]: [product].reduce(reduceLevels(fieldTarget), []),
    }))
    : [products].reduce(reduceLevels(fieldTarget), []);

  return fieldTarget === PARTS ? parts : targetLevel;

  function reduceLevels(field: string) {
    return (acc, level) => {
      const properties: string[] = Object.keys(level);

      if (properties.includes(field)) {
        if (field === PARTS) {
          parts.push(level[field]);
        }

        acc = [...acc, level[field]];

        return acc;
      }

      const property: string = properties.find((p: string) => p === COMPOSITIONS || p === ARTICLES);

      return {
        [COMPOSITIONS]: ({ compositions }) => compositions.reduce(reduceLevels(field), []),
        [ARTICLES]: ({ articles }) => articles.reduce(reduceLevels(field), []),
      }[property](level);
    };
  }
};

export const getCreationProductArticles = (product: ICreationProduct) => {
  switch (true) {
    case isMatch(product.familyId):
    case isTube(product.familyId):
      return reduceCreatioProjectProduct(product, PROJECT_CREATION_LEVELS.PARTS);

    default:
      return reduceCreatioProjectProduct(product, PROJECT_CREATION_LEVELS.ARTICLES);
  }
};
